import { TErrorInformation } from '@commonTypes/basic';

export const getCurrencySymbol = (code: string): string => {
  const dollarCodes = ['USD', 'CAD', 'AUD'];
  const euroCodes = ['EUR', 'EURO'];

  switch (true) {
    case dollarCodes.includes(code):
      return '$';

    case euroCodes.includes(code):
      return '€';

    default:
      return '';
  }
};

export const inchToCm = (value: number): number =>
  Math.round((Number(value.toFixed(2)) * 2.54 + Number.EPSILON) * 100) / 100;

export const parseResponseError = (error: TErrorInformation) => {
  return error && error.errorReason ? error.errorReason : 'Unknown error';
};
